import { ForwardedRef, forwardRef, HTMLProps, PropsWithChildren, ReactNode } from 'react';
import { CircularProgress, Stack, Typography } from '@mui/material';
import styles from './pageLayout.module.scss';
import React from 'react';
import cx from 'classnames';

type Props = {
  title?: string;
  titleAccessory?: ReactNode;
  description?: string;
  loading?: boolean;
  rightView?: ReactNode;
  bottomView?: ReactNode;
  pageClassName?: string;
};

const PageLayout = forwardRef<HTMLDivElement, PropsWithChildren<Props & HTMLProps<HTMLDivElement>>>(
  (
    {
      title,
      titleAccessory,
      description,
      rightView,
      bottomView,
      className,
      pageClassName = '',
      loading,
      children,
    }: PropsWithChildren<Props & HTMLProps<HTMLDivElement>>,
    ref: ForwardedRef<HTMLDivElement>,
  ) => {
    return (
      <div aria-label="page-layout-container" className={cx(styles.pageLayout, pageClassName)}>
        <div className={styles.headerContainer} ref={ref}>
          <div className={styles.header}>
            <div>
              {title && (
                <Typography variant="h3" className={styles.title}>
                  {title}
                  {titleAccessory}
                </Typography>
              )}
              {description && (
                <Typography variant="body2" className={styles.description}>
                  {description}
                </Typography>
              )}
            </div>
            {rightView}
          </div>

          {bottomView}
        </div>

        <div aria-label="children-container" className={[styles.content, className].join(' ')}>
          {loading ? (
            <Stack alignItems="center" justifyContent="center" minHeight={400}>
              <CircularProgress />
            </Stack>
          ) : (
            children
          )}
        </div>
      </div>
    );
  },
);

export default PageLayout;
